module.exports = __webpack_public_path__ + "img/jytd.ff7c075a.png";